<template>
  <div class="site-link">
    <h3>Retrouvez également</h3>
    <div class="flex">
      <div class="card" v-if="siteName !== 'Immobilier'">
        <div>
          <img class="logo" alt="Giordano Immobilier" src="../../assets/images/immobilier/logo-giordano-immobilier.svg"
            width="179px" height="46px" />
          <p v-html="societes ? societes.ti.d_description : ''"></p>
        </div>
        <a href="http://giordano-immobilier.com">
          <button class="cg-btn cg-btn-black card-see-more-btn">En savoir plus</button>
        </a>
      </div>
      <div class="card" v-if="siteName !== 'Patrimoine'">
        <div>
          <img class="logo" alt="Giordano Patrimoine" src="../../assets/images/patrimoine/giordano-patrimoine.svg"
            width="179px" height="46px" />
          <p v-html="societes ? societes.gp.d_description : ''"></p>
        </div>
        <a href="http://giordano-patrimoine.com">
          <button class="cg-btn cg-btn-black card-see-more-btn">En savoir plus</button>
        </a>
      </div>
      <div class="card" v-if="siteName !== 'Courtage'">
        <div>
          <img class="logo" alt="Giordano Courtage" src="../../assets/images/courtage/giordano-courtage.svg" width="179px"
            height="46px" />
          <p v-html="societes ? societes.cg.d_description : ''"></p>
        </div>
        <a href="http://giordano-courtage.com">
          <button class="cg-btn cg-btn-black card-see-more-btn">En savoir plus</button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import DataApi from 'fm-data-api'

export default {
  name: 'SiteLink',
  data: () => {
    return {
      societes: null
    }
  },
  props: {
    siteName: String
  },
  async beforeMount() {
      const options = {
          apiUrl: this.$apiUrl,
          databaseName: this.$databaseName,
          token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      await this.dataApi.getRecords('W_Societe', '', '', '')
      .then((response) => {
        this.societes = {}
        for (let societe of response) {
          societe = societe.fieldData
          this.societes[societe.d_codeSociete] = societe
        }
      })
    }
}
</script>

<style lang="scss">
.site-link {
  max-width: var(--max-width);
  width: 100%;
  padding: 64px 16px;

  .flex {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }

  .card {
    max-width: 500px;
    width: 100%;
    height: 500px;
    margin: 31px 32px 0 0;
    padding: 64px 64px 21px 64px;
    border-radius: 4px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    background-image: linear-gradient(to bottom, #fff 34%, rgba(255, 255, 255, 0) 75%), linear-gradient(to bottom, #fff, #fff);
    text-align: start;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    img {
      margin-bottom: 22px;
      align-self: start;
      max-width: 100%;
    }

    &>div {
      height: 290px;
      overflow: hidden;
    }

    .card-see-more-btn {
      width: 100%;
      height: 40px;
      margin-top: auto;
    }
  }
}

@media (max-width: 700px) {
  .site-link {
    .card {
      height: 100%;

      &>div {
        height: 100%;
      }
    }
  }
}
</style>